import React from 'react';

const Logo = ({ navbar_current_mode }) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 80,
      }}
    >
      {process.env.REACT_APP_THEME === 'NETWORK_COMMANDER' ? (
        <img
          src="/logo-network-commander-logo-1500-white.png"
          alt="Logo"
          style={{ width: '80%' }}
        />
      ) : process.env.REACT_APP_THEME === 'WORKSPACEGEEK' ? (
        <img
          src="/workspace-geek-logo-2.png"
          alt="Network Commander Logo"
          style={{ width: '90%' }}
        />
      ) : process.env.REACT_APP_THEME === '640TECH' ? (
        <img
          src="/640-tech-logo-light.png"
          alt="640Tech Logo"
          style={{ width: '70%', maxHeight: '60px', objectFit: 'contain' }}
        />
      ) : (
        <h3
          style={{
            color: navbar_current_mode === 'dark' ? '#fff' : '#000',
            fontSize: '1.8rem',
            fontWeight: 'bold',
          }}
        >
          TechTRW
        </h3>
      )}
    </div>
  );
};

export default Logo;
